import * as angular from 'angular';

import * as AddressSelectorComponent from './address-selector';
import * as AppHeaderComponent from 'common/source/components/app-header';
import * as DesktopHeaderComponent from './app-header/desktop';
import * as MobileHeaderComponent from './app-header/mobile';
import * as AppFooterComponent from 'common/source/components/app-footer';
import * as BooleanCellComponent from './boolean-cell';
import * as FactCellComponent from './fact-cell';
import * as GreetingComponent from './greeting';
import * as HippoButtonComponent from 'common/source/components/hippo-button';
import * as HippoIconComponent from 'common/source/components/hippo-icon';
import * as InfoIconWithTooltipComponent from 'common/source/components/info-icon-with-tooltip';
import * as LocationMapComponent from './location-map';
import * as LogoutComponent from 'common/source/components/logout';
import * as ContactUsComponent from 'common/source/components/contact-us';
import * as HippoNumberComponent from 'common/source/components/hippo-number';
import * as NavigationComponent from './navigation';
import * as PageHeaderComponent from './page-header';
import * as PolicyStatusDescription from './policy-status-description';
import * as PolicyStatusIcon from './policy-status-icon';
import * as SectionHeaderComponent from './section-header';
import * as SidebarComponent from './sidebar';
import * as ContactMeCardComponent from './contact-me-card';
import * as EscrowFormComponent from 'common/source/components/escrow-form';
import * as PageSelectorComponent from './page-selector';
import * as AccordionComponent from 'common/source/components/accordion';
import * as HippoInputComponent from 'common/source/components/hippo-input';
import * as CoverageSectionComponent from 'common/source/components/icon-title-section';
import * as StateDropdown from 'common/source/components/state-dropdown';
import * as AddItemsToPolicyCardComponent from './add-items-to-policy-card';
import * as IntercomComponent from './intercom';
import * as ACHFormComponent from 'common/source/components/ach-form';
import * as MobileQuickLinks from './mobile-quick-links';
import * as PaymentStatusIcon from './payment-status-icon';
import * as PaymentStatusLabel from './payment-status-label';

const module = angular.module('customerPortalComponents', [
    ACHFormComponent.module.name,
    AddItemsToPolicyCardComponent.module.name,
    AddressSelectorComponent.module.name,
    AppHeaderComponent.module.name,
    AppFooterComponent.module.name,
    BooleanCellComponent.module.name,
    FactCellComponent.module.name,
    GreetingComponent.module.name,
    HippoButtonComponent.module.name,
    HippoIconComponent.module.name,
    InfoIconWithTooltipComponent.module.name,
    LocationMapComponent.module.name,
    LogoutComponent.module.name,
    ContactUsComponent.module.name,
    HippoNumberComponent.module.name,
    NavigationComponent.module.name,
    PageHeaderComponent.module.name,
    PolicyStatusDescription.module.name,
    PolicyStatusIcon.module.name,
    SectionHeaderComponent.module.name,
    SidebarComponent.module.name,
    ContactMeCardComponent.module.name,
    EscrowFormComponent.module.name,
    PageSelectorComponent.module.name,
    AccordionComponent.module.name,
    HippoInputComponent.module.name,
    CoverageSectionComponent.module.name,
    DesktopHeaderComponent.module.name,
    MobileHeaderComponent.module.name,
    StateDropdown.module.name,
    IntercomComponent.module.name,
    MobileQuickLinks.module.name,
    PaymentStatusIcon.module.name,
    PaymentStatusLabel.module.name
]);

export { module };
